module.exports = __webpack_public_path__ + "static/media/pf34.2b07bea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf34.png
// module id = 2734
// module chunks = 0